require("angular");

module.exports = angular.module("brackets", []);